import { render, staticRenderFns } from "./JdsCheckboxGroup.vue?vue&type=template&id=61de0fea&scoped=true&"
import script from "./JdsCheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./JdsCheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./JdsCheckboxGroup.vue?vue&type=style&index=0&id=61de0fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de0fea",
  null
  
)

export default component.exports